<template>
    <cms-block v-bind="$props" block-component="b-navbar" @click.native="onSelected" :style="blockStyle"
               :block-component-params="{ 'sticky': !isEditMode }" :block-class="[`anchor-${block.mediaProxy.anchor} orientation-${block.orientation}`]"
               :container-component-params="{ fillParent: block.orientation === 'vertical' }" :horizontal="block.orientation === 'horizontal'">
        <b-navbar-nav>
            <cms-component-image comp-id="logo" :component="block.logo" v-bind="componentProps"/>
            <cms-component-navigation-links comp-id="leftLinks" class="menu-before" :component="block.leftLinks" v-bind="componentProps" in-main-menu @collapse-nav-menu="toggleMenu()"/>
            <cms-component-navigation-links comp-id="links" class="menu-center" :component="block.links" v-bind="componentProps" in-main-menu @collapse-nav-menu="toggleMenu()"/>
            <cms-component-navigation-links comp-id="rightLinks" class="menu-after" :component="block.rightLinks" v-bind="componentProps" in-main-menu @collapse-nav-menu="toggleMenu()"/>
        </b-navbar-nav>
        <template v-if="isCollapsing && isMobileLayoutOrPreview">
            <b-collapse :visible="mobileMenuVisible || isSelected" class="mobile-menu">
                <div v-if="!isMobileLayoutOrPreview" class="mobile-menu-overlay" @click="mobileMenuVisible = false"></div>
                <div class="mobile-menu-content">
                    <cms-component-navigation-links comp-id="leftLinks" :component="block.leftLinks" @navigated="toggleMenu()" v-bind="componentProps" in-main-menu collapsed/>
                    <cms-component-navigation-links comp-id="links" :component="block.links" @navigated="toggleMenu()" v-bind="componentProps" in-main-menu collapsed/>
                    <cms-component-navigation-links comp-id="rightLinks" :component="block.rightLinks" @navigated="toggleMenu()" v-bind="componentProps" in-main-menu collapsed/>
                </div>
            </b-collapse>
        </template>
        <template v-if="isCollapsing && (isKioskDevice || isDesktopDevice)">
            <e-mobile-modal v-model="mobileMenuVisible" :title="$t('map.common.menu')">
                <cms-component-navigation-links comp-id="leftLinks" :component="block.leftLinks" @navigated="toggleMenu()" v-bind="componentProps" in-main-menu collapsed/>
                <cms-component-navigation-links comp-id="links" :component="block.links" @navigated="toggleMenu()" v-bind="componentProps" in-main-menu collapsed/>
                <cms-component-navigation-links comp-id="rightLinks" :component="block.rightLinks" @navigated="toggleMenu()" v-bind="componentProps" in-main-menu collapsed/>
            </e-mobile-modal>
        </template>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import EMobileModal from "@components/e-mobile-modal.vue";

// cms-block-menu #hot-reload-debug
export default {
    name: `cms-block-menu`,
    components: {EMobileModal, CmsBlock},
    extends: CmsBlock,
    computed: {
        blockStyle() {
            return {
                "--menu-size": `${this.block.mediaProxy.size}px`
            }
        },
        isCollapsing() {
            return this.block.links.isCollapsing() || this.block.leftLinks.isCollapsing() || this.block.rightLinks.isCollapsing();
        }
    },
    data() {
        return {
            mobileMenuVisible: false
        }
    },
    methods: {
        toggleMenu() {
            this.mobileMenuVisible = !this.mobileMenuVisible;
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-menu {
    padding: 0;
    z-index: 1001 !important;

    .cms-container {
        display: flex;
        align-items: center;
        padding: 0;
        background-color: inherit;

        .navbar-collapse {
            width: 100%;
        }

        .navbar-nav {
            align-items: center;
        }
    }

    &.orientation-horizontal {
        position: sticky;
        width: 100%;
        height: var(--menu-height);

        ::v-deep > .cms-container {
            height: var(--menu-height);
        }

        .navbar-nav {
            height: var(--menu-height);
            width: 100%;
        }

        ::v-deep .menu-before {
            margin-right: auto;
            justify-content: start;
        }
        ::v-deep .menu-after {
            margin-left: auto;
            justify-content: end;
        }
    }

    &.orientation-vertical {
        position: fixed;
        z-index: 1;
        //height: 100%;
        width: var(--menu-width);

        ::v-deep > .cms-container {
            width: var(--menu-width);
            max-height: var(--floating-menu-height);
        }

        .navbar-nav {
            flex-direction: column !important;
            flex-grow: 1;
            width: var(--menu-width);
        }

        .menu-before {
            margin-bottom: auto;
            justify-content: start;
        }
        .menu-after {
            margin-top: auto;
            justify-content: end;
        }
    }

    &.anchor-left {
        top: 0;
        left: 0;
        bottom: 0;

        .mobile-menu-content {
            border-left: 1px solid var(--border-color);
        }
    }

    &.anchor-top {
        .mobile-menu-content {
            border-top: 1px solid var(--border-color);
        }
    }

    &.anchor-bottom {
        position: fixed;
        top: auto;
        bottom: 0;
        left: 0;
        right: 0;

        .mobile-menu-content {
            border-bottom: 1px solid var(--border-color);
        }
    }

    &.anchor-right {
        top: 0;
        right: 0;
        bottom: 0;

        .mobile-menu-content {
            border-right: 1px solid var(--border-color);
        }
    }

    > hr {
        width: 100%;
        margin: 0;
        border-bottom: 1px solid rgba(white, 0.05);
        //border-top: 1px solid rgba(black, 0.5);
    }

    .navbar-brand {
        display: flex;
        height: var(--menu-size);
        align-items: center;
        justify-content: center;
    }
}

.mobile-toggle {
    flex: 1;
}
.mobile-logo {
    margin-right: 0;
    max-width: initial !important;
    flex: 2;
}

.mobile-menu {
    position: fixed !important;
    top: var(--page-padding-top) !important;
    left: var(--page-padding-left) !important;
    right: var(--page-padding-right) !important;
    bottom: var(--page-padding-bottom) !important;
    z-index: 10;

    .mobile-menu-content {
        position: relative;
        z-index: 1;
        background: var(--scheme-bg);
        width: 512px;
        height: 100%;
        max-width: 100%;
    }

    .mobile-menu-overlay {
        position: fixed;
        top: var(--page-padding-top);
        left: var(--page-padding-left);
        right: var(--page-padding-right);
        bottom: var(--page-padding-bottom);
        background-color: rgba(0, 0, 0, 0.5);
    }
}

.web-editor {
    .mobile-menu {
        // leave space for padding rule panel
        top: calc(var(--page-padding-top) + 25px) !important;
    }
}

:deep(.menu-language) {
    width: 100%;
    margin: 0;
    color: white !important;

    &:hover, &:active {
        background: white !important;

        button {
            color: black !important;
        }
    }

    button {
        padding: 1rem;
        width: 100%;
        color: white !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
    }

    .dropdown-menu {
        z-index: 1001;
        max-width: 200px;
    }

    .dropdown-item {
        padding: 0.25rem 1rem;
        max-width: 200px;
        min-width: 0;
    }
}

.floating-menu {
    .cms-block-menu {
        &.orientation-vertical {
            background: transparent !important;

            ::v-deep > .cms-container {
                background: var(--scheme-bg);
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
            }
        }
    }
}

.flag-icon {
    width: 20px;
    height: 14px;
    object-fit: cover;
}
</style>
